import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import urlJoin from 'url-join';
import { getImageByWidth } from '../../utils/api';
import BarnDoors from './BarnDoors';
import BgVideo from './BgVideo';
import CoverText from './CoverText';


class Cover extends Component {
  constructor (props) {
    super(props);
    this.state = {
      overlaysIn: false,
      videoIn: true,
      exiting: false,
      videoReady: false,
      showLoadingSpinner: false,
      nextUrl: '',
    };
    this.timeouts = [];
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleVideoReady = this.handleVideoReady.bind(this);
    this.startInAnimation = this.startInAnimation.bind(this);
    this.startOutAnimation = this.startOutAnimation.bind(this);
  }

  componentDidMount () {
    const { breakpoint, video } = this.props;

    // If no background video is provided, start the animation
    // without waiting for a video loaded event
    if (!breakpoint.greaterThan.sm || !video) {
      this.startInAnimation();
    }

    // Show loading spinner after a slight delay, so it doesn't
    // momentarily flash on fast connections
    this.timeouts.push(
      setTimeout(() => {
        if (!this.state.videoReady) {
          this.setState({ showLoadingSpinner: breakpoint.greaterThan.sm });
        }
      }, 500)
    );
  }

  componentDidUpdate (prevProps, prevState) {
    const { videoReady, exiting } = this.state;
    if (videoReady && !prevState.videoReady) {
      this.startInAnimation();
    }

    if (exiting && !prevState.exiting) {
      this.startOutAnimation();
    }
  }

  componentWillUnmount () {
    this.timeouts.forEach(t => clearTimeout(t));
  }

  handleVideoReady (e) {
    this.setState({
      videoReady: true,
      showLoadingSpinner: false,
    });
  }

  handleButtonClick (uid) {
    const nextUrl = this.getTitleUrl(uid);
    this.setState({
      exiting: true,
      nextUrl,
    });
  }

  getTitleUrl (uid) {
    const { ui, sections } = this.props;
    const activeSectionIndex = sections.navItems.indexOf(ui.activeSection);
    const activeSectionItems = sections.bySlug[ui.activeSection].items;
    const sectionBasePath = `/${activeSectionIndex + 1}/${ui.activeSection}`;
    const targetTitleIndex = activeSectionItems.findIndex(item => item.uid === uid);
    const targetTitle = activeSectionItems[targetTitleIndex];

    return targetTitleIndex > 0 ? urlJoin(sectionBasePath, targetTitle.urlSlug) : sectionBasePath;
  }

  startInAnimation () {
    const { animationDelay, breakpoint } = this.props;

    this.timeouts.push(
      setTimeout(() => {
        this.setState({ overlaysIn: true });
      }, breakpoint.greaterThan.sm ? (animationDelay * 1000) : 300)
    );
  }

  startOutAnimation () {
    const { animateOut, breakpoint } = this.props;
    if (animateOut === false || !breakpoint.greaterThan.sm) {
      this.navigateToTitle();
    } else {
      this.setState({
        overlaysIn: false,
        videoIn: false,
      });

      this.timeouts.push(
        setTimeout(() => {
          this.navigateToTitle();
        }, 1100)
      );
    }
  }

  navigateToTitle () {
    const { history } = this.props;
    const { nextUrl } = this.state;
    history.push(nextUrl);
  }

  render () {
    const { breakpoint, name, longDescription, buttons, footerText, video, image, videoAlign, displayLogo } = this.props;
    const { overlaysIn, videoIn, showLoadingSpinner } = this.state;
    const containerClasses = classNames({
      'cover-wrap': true,
      'h-100': true,
      'loading-spinner-50': showLoadingSpinner && breakpoint.greaterThan.sm && !!video,
    });
    const containerStyles = { position: 'relative' };
    if (image && !breakpoint.greaterThan.sm) {
      const imageVersion = getImageByWidth(image.versions, 900);
      if (imageVersion) {
        containerStyles.backgroundImage = `url('${imageVersion.url}')`;
      }
    }
    const videoVersion = video ? video.versions.find(v => v.format === 'mp4') : null;
    return (
      <div className={containerClasses} style={containerStyles}>
        {breakpoint.greaterThan.sm ? (
          <BgVideo
            show={videoIn}
            duration={700}
            sourceMp4={videoVersion.url}
            verticalAlign={videoAlign}
            onVideoReady={this.handleVideoReady}
          />
        ) : null}
        <BarnDoors show={overlaysIn} duration={1000} />
        <CoverText
          show={overlaysIn}
          duration={500}
          title={name}
          displayLogo={displayLogo}
          description={longDescription}
          buttons={buttons}
          footerText={footerText}
          onButtonClick={this.handleButtonClick}
        />
      </div>
    );
  }
}

Cover.propTypes = {
  animationDelay: PropTypes.number,
  name: PropTypes.string,
  longDescription: PropTypes.string,
  buttons: PropTypes.array,
  footerText: PropTypes.string,
  video: PropTypes.object,
  image: PropTypes.object,
};

Cover.defaultProps = {
  animationDelay: 1.4, // Delay in seconds before starting to animate in overlay elements
};

const mapStateToProps = ({ breakpoint, ui, sections }) => ({ breakpoint, ui, sections });

export default connect(mapStateToProps)(Cover);



// WEBPACK FOOTER //
// ./src/components/Covers/Cover.js